<template>
  <div :class="s.aboutCentent">
    <div v-if="navs" :class="s.nav">
      <div :class="s.navBar">
        <div v-for="(item, index) in navs" :class="[
          s.navSingle,
          { [s.heighLight]: index === navIndex },
        ]" :key="item.nav" @click="changeNav(index)">
          {{ item.nav }}
        </div>
      </div>
    </div>
    <div v-if="item" :class="[s.textBox, {
      [s.publicity]: key === 'publicity',
      [s.textBoxWithNav]: !!navs
    }]">
      <h3 v-html="item.title"></h3>
      <Publicity v-if="key === 'publicity'"/>
      <Licenses v-else-if="key === 'licenses'"/>
      <PublicInfo v-else-if="key === 'public-info'"/>
      <Introduce v-else/>
    </div>
  </div>
</template>

<script>
import { topics } from '@/constant';

import Introduce from './introduce'
import PublicInfo from './public-info'
import Licenses from './licenses'
import Publicity from './publicity'

export default {
  components: {
    Introduce,
    PublicInfo,
    Licenses,
    Publicity
  },
  computed: {
    s() {
      return this.$style;
    },
    topic() {
      return topics[this.topicIndex]
    },
    navs() {
      const { navs: data } = this.topic || {}
      if (!data || !data.length) {
        return null
      }
      return data
    },
    item() {
      if (this.navs) {
        return this.navs[this.navIndex]
      }

      return this.topic
    },
    key() {
      if (this.item) {
        return this.item.key
      }
      return null
    }
  },
  watch: {
    $route: {
      handler(val) {
        const { selected } = val.query || {}
        this.topicIndex = Number.parseInt(selected)
      },
      // 深度观察监听
      deep: true,
    },
  },
  data() {
    const { selected } = this.$route.query || {}
    return {
      navIndex: 0,
      topicIndex: Number.parseInt(selected)
    };
  },
  methods: {
    changeNav(index) {
      this.navIndex = index;
    }
  }
};
</script>

<style scoped lang="less" module>
.aboutCentent {
  //   height: 1024px;
  overflow: hidden;
  position: relative;
}

.nav {
  position: absolute;
  left: 0;
  top: 110px;
  border-radius: 0 30px 30px 0;
  overflow: hidden;
  box-shadow: 5px 5px 5px 5px #eee;
}

.navSingle {
  width: 300px;
  height: 58px;
  line-height: 58px;
  background-color: #fff;
  color: #9b9b9b;
  cursor: pointer;
}

.heighLight {
  background-color: #1669bc;
  color: #fff;
}

.textBox {
  //   width: 1075px;
  margin: 30px;
  padding: 30px 60px 30px;
  box-sizing: border-box;
  box-shadow: 0px 5px 5px 5px #eee;
  text-align: left;

  &.publicity {
    margin: 30px 15%;
  }

  h3 {
    font-size: 20px;
    color: #1669bc;
  }

  p {
    font-size: 15px;
    line-height: 30px;
    text-indent: 2em;
  }

  font {
    margin-left: -2em;
  }
}

.textBoxWithNav {
  margin: 110px 30px 10px 344px;
}
</style>
